import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Ensures scroll resets and back/forward navigation re-renders correctly. */
export default function ScrollRestoration() {
  const { pathname, key } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, key]);

  return null;
}
